import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Form from 'components/form/Form';
import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	@media (min-width: 1367px) {
		padding-right: 0 !important;
	}
`;

export const GeneralSettingsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex: 1;

	.formitem-column {
		width: 100%;
	}

	@media ${Breakpoints.mobileLandscape} {
		flex: unset;
		width: 100%;
		margin: 0;
	}

	@media (min-width: 1367px) {
		flex: 0;
	}
	.accountRemoval {
		button {
			&.outline {
				border-color: var(--red);
				color: var(--red);

				:not(.disabled):hover {
					background: var(--red-10);
					color: var(--white);

					.button-text,
					.button-icon {
						color: var(--red);
					}
				}

				.button-text,
				.button-icon {
					color: var(--red);
				}
			}
		}
	}
`;

export const PackageHeader = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const PackageNameContainer = styled.div`
	display: flex;
	align-items: baseline;
	gap: 0.5rem;
	flex-direction: column;
	width: 100%;
`;

export const ModuleItem = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(23rem, 1fr));
	gap: 1rem;
	max-height: calc(100vh - 37rem);
	justify-content: flex-start;

	@media ${Breakpoints.tablet} {
		grid-template-columns: repeat(auto-fit, minmax(28rem, 1fr));
	}

	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
	}
`;

export const ModuleContainer = styled.div`
	width: auto;

	* {
		cursor: ${({ isPlanActive }) => (isPlanActive ? 'pointer' : 'not-allowed')};
	}
`;

export const BadgeCss = css`
	background-color: var(--blue);
	padding: 0.5rem;
	border-radius: 4px;
	color: var(--alwaysWhiteColor);
`;

export const PackageInfo = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	justify-content: space-between;
`;
export const PackageInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const ToolTipContainer = styled.div`
	width: 25rem;
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	* {
		cursor: default;
	}
	@media ${Breakpoints.mobile} {
		width: 21rem;
	}
`;

export const IconContainer = styled.div`
	width: 2.5rem;
	height: 2rem;
	display: flex;
	align-items: center;
`;

export const SkeletonContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 1rem;
	padding-top: 0.5rem;
`;

export const StyledCard = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 2.5rem;
	width: 100%;
	max-height: unset;
	overflow: unset;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding: 1rem;
		gap: 1rem;
	}
`;

export const StyledForm = styled(Form)`
	gap: 3rem;
	display: flex;
	flex-direction: column;
	max-height: unset;
	flex-direction: row;
	padding-bottom: 3rem !important;
	flex-direction: column;
	flex-wrap: nowrap;
	@media ${Breakpoints.mobile} {
		padding: 0 !important;
		margin-bottom: 10rem;
	}
	.base-form-item {
		width: 100%;
		margin: unset !important;
		/* margin-left: unset !important;
		margin-right: auto !important; */
		.line {
			width: 100%;
			margin: 0;
		}
	}
`;

export const AccountRemovalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

export const RadioContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-bottom: 1rem;
`;

export const RadioItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
	padding: 0.5rem;
	border-radius: 4px;
	transition: background-color 0.2s;

	&:hover {
		background-color: var(--gray-100);
	}
`;

export const InvoiceTypeItemContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding-left: ${({ noPadding }) => (noPadding ? '0' : '2.5rem')};

	> .form-item {
		width: ${({ fullWitdhItems }) => (fullWitdhItems ? '100%' : '50%')};
		margin: unset !important;
		& > :first-of-type {
			margin-bottom: 1rem;
			& > label {
				display: flex;
				flex-direction: row;
				align-items: center;
			}
		}

		@media ${Breakpoints.desktop} {
			width: 100%;
		}
	}
	${({ gap }) => gap && `gap: ${gap};`}

	body[dir='rtl'] & {
		padding-left: unset;
		padding-right: 2.5rem;
	}
	.badge-container {
		display: block;
		width: fit-content;
		margin-left: 1rem;
		.typography {
			color: var(--white);
		}
	}
`;

export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: baseline;

	div > svg {
		color: ${({ color }) => color || 'var(--red)'};
	}

	p {
		color: ${({ color }) => color || 'var(--red)'};
	}
`;

export const FlexBox = styled.div`
	display: flex;
	gap: 1rem;
	width: 100%;
	${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent};`}
	${({ $alignItems }) => $alignItems && `align-items: ${$alignItems};`}
	${({ $flexDirection }) => $flexDirection && `flex-direction: ${$flexDirection};`}
	${({ $gap }) => $gap && `gap: ${$gap};`}
`;

export const FormContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 1rem;
	width: 100%;
	justify-content: space-between;
	.form-item {
		margin: 0 !important;
		padding-right: 0;
		padding-left: 0;
	}
	& > div {
		width: 49% !important;
	}
	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
		gap: 0.5rem;
		& > div {
			width: 100% !important;
		}
	}
`;

export const NewAccountTypeArea = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	margin-left: var(--margin-2);
`;

export const SectionTitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	margin-bottom: 1.5rem;
`;

export const SectionRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 2rem;
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: flex-start;
	}

	.delete-account {
		background-color: var(--red-10);
		border-color: var(--red);
		color: var(--red);
		& > .button-icon {
			color: var(--red);
		}
		& > .button-text {
			color: var(--red);
		}
		&:not(.disabled):hover {
			background: var(--red);
		}
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 1rem;
	@media ${Breakpoints.tablet} {
		display: none;
	}
	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const AddressContainer = styled.div`
	width: -webkit-fill-available;
	margin: 0 -1rem;

	& .col-12 {
		width: -webkit-fill-available;
	}

	& .col-6 {
		width: 50%;
	}
`;
